import { Injectable } from '@angular/core';

import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { GridService } from '@core/services';

import { ConsigneeService } from '@consignee/services';

import * as ConsigneeActions from './consignee.actions';

@Injectable()
export class ConsigneeEffects {
  constructor(private actions$: Actions, private consigneeService: ConsigneeService, private gridService: GridService) {}

  ConsigneeLookupDialogRequestData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        ConsigneeActions.ConsigneeLookupDialogRequestData,
        ConsigneeActions.ConsigneeLookupDialogRequestDataWithFilters,
        ConsigneeActions.ConsigneeLookupDialogRequestDataWithParameters
      ),
      concatLatestFrom(({ id }) => [
        this.gridService.filters$(id),
        this.gridService.page$(id),
        this.gridService.rows$(id),
        this.gridService.sortsObject$(id),
      ]),
      exhaustMap(([{ id }, filters, page, rows, sorts]) =>
        this.consigneeService.getConsigneeLookup({ filters, page, rows, sorts }).pipe(
          map((data) => ConsigneeActions.ConsigneeLookupDialogRequestDataSuccess({ id, data })),
          catchError((_error) => of(ConsigneeActions.ConsigneeLookupDialogRequestDataFailure({ id })))
        )
      )
    );
  });

  CustomerConsigneeLookupDialogRequestData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        ConsigneeActions.CustomerConsigneeLookupDialogRequestData,
        ConsigneeActions.CustomerConsigneeLookupDialogRequestDataWithFilters,
        ConsigneeActions.CustomerConsigneeLookupDialogRequestDataWithParameters
      ),
      concatLatestFrom(({ id }) => [
        this.gridService.filters$(id),
        this.gridService.page$(id),
        this.gridService.rows$(id),
        this.gridService.sortsObject$(id),
      ]),
      exhaustMap(([{ id }, filters, page, rows, sorts]) =>
        this.consigneeService.getCustomerConsigneeLookup({ filters, page, rows, sorts }).pipe(
          map((data) => ConsigneeActions.CustomerConsigneeLookupDialogRequestDataSuccess({ id, data })),
          catchError((_error) => of(ConsigneeActions.CustomerConsigneeLookupDialogRequestDataFailure({ id })))
        )
      )
    );
  });
}
